import React from 'react';

import Modal from 'CommonComponents/Modal';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ConfirmAddSubcategoryModal(props) {
    const close = () => {
        props.modal.hide();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader close={close}>
                <span className="tw-text-red-500">{$t('Warning')}!</span>
            </ModalHeader>
            <div className="tw-rounded-b tw-mb-6">
                {$t(
                    'You are adding a new sub-category to an existing sub-category. Any values previously added for this sub-category in the Venues - Daily Demand will be moved to the first item in the new sub-category being created',
                )}
            </div>
            <ModalFooter
                submitButtonVariant="primary"
                cancelButtonText={$t('Cancel')}
                primaryButtonText={$t('Confirm')}
                onCancel={close}
                handleSubmit={props.onConfirm}
            ></ModalFooter>
        </Modal>
    );
}
